/*
NOTE: Where selectors are given elements could also be given

Form module id example: \Modules\Form\Form::getID(),

Inputs example: {
	houseNumber: 'input[name="house_number"]',
	houseNumberAddon: 'input[name="house_number_addon"]',
	postalCode: 'input[name="postal_code"]',
}

Outputs example: {
	countryCode: 'select[name="country"]',
	locality: 'input[name="locality"]',
	state: 'input[name="state"]',
	streetName: 'input[name="street_name"]',
	// Other options are `country`, `stateCode`.
}

Wrapper example: '#form-id'.
NOTE: If the wrapper is not an element then the elements will be selected from the entire document.
*/

const inputAddressKeys = ['postalCode', 'houseNumber', 'houseNumberAddon'];
export const filleAddress = (formModuleId, inputs, outputs, wrapper = null) => {
  if (typeof wrapper === 'string') {
    wrapper = document.body.querySelector(wrapper);
  }
  if (!wrapper) {
    wrapper = document.body;
  }
  for (const addressKey in outputs) {
    if (typeof outputs[addressKey] === 'string') {
      outputs[addressKey] = wrapper.querySelector(outputs[addressKey]);
    }
  }

  // Fetching index is used to prevent an earlier request form being used when a later request is already send out because the request is non-blocking.
  let fetchingIndex = 0;
  for (const addressKey in inputs) {
    if (inputAddressKeys.indexOf(addressKey) < 0) {
      console.warn('fillAddress: addressKey of "' + addressKey + '" not recognized.');
      continue;
    }
    if (typeof inputs[addressKey] === 'string') {
      inputs[addressKey] = wrapper.querySelector(inputs[addressKey]);
    }
    if (!inputs[addressKey]) {
      console.warn('fillAddress: element not given for input with key "' + addressKey + '".');
      continue;
    }
    inputs[addressKey].addEventListener('change', () => {
      fetchingIndex++;
      const localFetchingIndex = fetchingIndex;
      let url = 'index.php?moduleid=' + formModuleId + '&action=api_get_address&postal_code=' + inputs.postalCode.value + '&house_number=' + inputs.houseNumber.value;
      if (inputs.houseNumberAddon) {
        url += '&house_number_addon=' + inputs.houseNumberAddon.value;
      }
      fetch(url).then(response => response.json()).then(result => {
        if (!result || localFetchingIndex !== fetchingIndex) {
          return;
        }
        for (const addressKey in outputs) {
          if (outputs[addressKey]) {
            outputs[addressKey].value = result[addressKey] ? result[addressKey] : '';
            outputs[addressKey].setAttribute('value', result[addressKey] || '');
            if (inputAddressKeys.indexOf(addressKey) < 0) {
              outputs[addressKey].dispatchEvent(new CustomEvent('change'));
            }
          }
        }
      });
    });
  }
};
export default filleAddress;